import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import SidebarBuildingWallColorIcon from 'components/layout/buttons/SideBarBuildingWallColorIcon';
import translations from 'services/translations/translations';

const BuildingWallColorIcon = (): JSX.Element => {
  const { t } = useTranslation([translations.leftBar]);
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const [active, setActive] = useState(true);

  const id = 'left-bar-building-wall-color-icon';

  const toggleActive = () => {
    setActive(!active);
    window.ToggleBuildingWallColor();
  };

  return (
    <>
      <SidebarBuildingWallColorIcon
        active={active}
        className="left-bar-icon"
        id={id}
        onClick={toggleActive}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipIsOpen}
        target={id}
        toggle={() => setTooltipIsOpen(!tooltipIsOpen)}
      >
        {t(`${translations.leftBar}:tooltips:Toggle building wall color`)}
      </Tooltip>
    </>
  );
};

export default BuildingWallColorIcon;
